import React from 'react'
import {Text, Flex, useStyleConfig, Box, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {CheckIcon} from '../../../components/icons/others'
import {remCalc} from '../../../theme/_utils'

const ProductTips = () => {
    const {formatMessage} = useIntl()
    const styles = useStyleConfig('ProductDocumentation')

    return (
        <VStack spacing={remCalc(8)} align="stretch">
            <Flex data-testid="product-tip" alignItems="center" gap={remCalc(10)}>
                <Box {...styles.tipIconBox}>
                    <CheckIcon {...styles.tipIcon} />
                </Box>
                <Text {...styles.tipText} textStyle="body-medium">
                    {formatMessage({
                        id: 'product_detail.product_documentation.product_tips',
                        defaultMessage: 'Product Tips',
                    })}
                </Text>
            </Flex>

            <Flex data-testid="product-tip" alignItems="center" gap={remCalc(10)}>
                <Box {...styles.tipIconBox}>
                    <CheckIcon {...styles.tipIcon} />
                </Box>
                <Text {...styles.tipText} textStyle="body-medium">
                    {formatMessage({
                        id: 'product_detail.product_documentation.news_offers',
                        defaultMessage: 'News & Special offers',
                    })}
                </Text>
            </Flex>

            <Flex data-testid="product-tip" alignItems="center" gap={remCalc(10)}>
                <Box {...styles.tipIconBox}>
                    <CheckIcon {...styles.tipIcon} />
                </Box>
                <Text {...styles.tipText} textStyle="body-medium">
                    {formatMessage({
                        id: 'product_detail.product_documentation.fast_support',
                        defaultMessage: 'Fast Support',
                    })}
                </Text>
            </Flex>
        </VStack>
    )
}

export default ProductTips
